<script>
    import {setContext} from 'svelte';
    import {getNextInputId} from '../../helper/UIHelper';  

    let className = "";
    export {className as class};
    let uid = getNextInputId();

    setContext('input_uid', uid);

</script>

<div class="relative {className}">
    <slot></slot>
</div>